var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.43404 2.30813H2.90973C2.53584 2.30813 2.17727 2.44428 1.9129 2.68662C1.64852 2.92896 1.5 3.25765 1.5 3.60038V10.7078C1.5 11.0505 1.64852 11.3792 1.9129 11.6215C2.17727 11.8639 2.53584 12 2.90973 12H10.6632C11.0371 12 11.3957 11.8639 11.6601 11.6215C11.9244 11.3792 12.0729 11.0505 12.0729 10.7078V7.47713M11.0763 1.39451C11.2063 1.27109 11.3619 1.17264 11.5339 1.10491C11.7059 1.03719 11.8908 1.00154 12.078 1.00005C12.2652 0.998558 12.4508 1.03125 12.6241 1.09623C12.7973 1.1612 12.9547 1.25716 13.0871 1.37849C13.2195 1.49982 13.3241 1.64411 13.395 1.80292C13.4659 1.96173 13.5016 2.13189 13.4999 2.30348C13.4983 2.47506 13.4594 2.64463 13.3855 2.80229C13.3117 2.95995 13.2043 3.10254 13.0696 3.22175L7.01767 8.76938H5.02432V6.94214L11.0763 1.39451Z",
    stroke: "#0369A1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.47d9ae2951385d7cd90053d22eec39dd.svg";
export { ForwardRef as ReactComponent };